// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3189":"889a6c2a","6950":"fbaa3b34","8097":"dc2e5980","8128":"95f94355","9967":"e060551b"}[chunkId] + ".chunk.css";
};